function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M20.7681 9.93421C21.1493 9.51491 21.1125 8.87225 20.6859 8.49917L11.2866 0.274763C10.86 -0.0983251 10.176 -0.0905096 9.75832 0.292383L0.3271 8.93766C-0.0905506 9.32055 -0.111049 9.96238 0.281715 10.3706L0.518169 10.6169C0.910454 11.0252 1.54454 11.0738 1.93353 10.7253L2.63837 10.0941V19.3351C2.63837 19.902 3.09777 20.361 3.66433 20.361H7.34065C7.9072 20.361 8.3666 19.902 8.3666 19.3351V12.8701H13.0558V19.3351C13.0476 19.9016 13.453 20.3606 14.0196 20.3606H17.9155C18.4821 20.3606 18.9415 19.9016 18.9415 19.3346V10.2242C18.9415 10.2242 19.1362 10.3948 19.3764 10.6059C19.6161 10.8165 20.1196 10.6476 20.5009 10.2279L20.7681 9.93421Z",
  fill: "#623B2A"
});

function SvgHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.886d4703670d47cc057f4273b3a6e39a.svg";
export { ForwardRef as ReactComponent };